const FLASH_REMOVE_MS = 1600;

/**
 * Scroll to a session-metadata / billing field in the note editor and flash it briefly.
 */
export function scrollToNoteMetadataField(fieldKey: string): boolean {
  const escaped =
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
      ? CSS.escape(fieldKey)
      : fieldKey.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

  const el = document.querySelector<HTMLElement>(`[data-note-field="${escaped}"]`);
  if (!el) return false;

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.style.transition = 'box-shadow 150ms ease';
  el.style.boxShadow = '0 0 0 3px var(--mantine-color-gold-4)';
  window.setTimeout(() => {
    el.style.boxShadow = '';
  }, FLASH_REMOVE_MS);
  return true;
}
